import type { ClientConfig } from '../types';

/** The original deployment. Its palette is the app's historical default. */
export const client99h: ClientConfig = {
  id: '99h',
  name: '99H.COM',

  theme: {
    app: '#f4f5f7',
    surface: '#ffffff',
    text: '#111111',
    muted: '#888888',
    // the existing grey caption tone
    'text-secondary': 'rgba(0, 0, 0, 0.35)',
    accent: '#1055ff',
    'accent-text': '#ffffff',
    link: '#1055ff',
    danger: '#ff3b30',
    brand: '#1055ff',
    'brand-soft': '#f2f2f3',
    line: '#e8e8e8',
    // The v2 Home cards: a pale vertical gradient under a white hairline.
    card: 'linear-gradient(180deg, #DEEEFF 0%, #FCFCFF 60.1%)',
    'card-border': '#ffffff',
    panel: 'rgba(255, 255, 255, 0.4)',
    // The scroll-revealed balance pill: translucent white, dark figure, and
    // a transparent refresh button carrying only a hairline.
    pill: 'rgba(255, 255, 255, 0.5)',
    'pill-action': 'transparent',
    'pill-action-border': '#eaeaea',
    'pill-action-text': 'var(--color-text)',
    'header-btn': 'transparent',
    'header-btn-border': 'var(--color-line)',
    sheet: '#ffffff',
    'sheet-contrast': '#ffffff',
    'sheet-contrast-text': 'var(--color-text)',
    // The page tone, which is what these pills have always been: on a white
    // card the recessed value reads as the page showing through.
    field: 'var(--color-app)',
    'sheet-border': '#f9f9f9',
    'table-head': '#f2f2f3',
    'table-stripe': '#f2f3f4',
    track: 'rgba(0, 0, 0, 0.05)',
    'page-glow': 'linear-gradient(180deg, #e4ecff 0%, #f5f5f5 100%)',
    // The Tailwind palette values these chips have always resolved to:
    // emerald-500 / amber-100 + amber-700 / rose-100 + rose-600.
    positive: '#10b981',
    'status-pending': '#fef3c7',
    'status-pending-text': '#b45309',
    'status-failed': '#ffe4e6',
    'status-failed-text': '#e11d48',
    'status-success': '#ecfdf5',
    'status-success-text': '#10b981',
    'option-active': '#f2f2f2',
    'warn-soft': 'rgba(208, 126, 55, 0.1)',
    gain: '#00A957',
    loss: '#EE2C2C',
    tabbar: 'rgba(255, 255, 255, 0.9)',
    'tabbar-band': 'rgba(255, 255, 255, 0.1)',
    'tabbar-active': 'var(--color-tab-active)',
    'tabbar-active-text': 'var(--color-brand)',
    'nav-inactive': 'var(--color-text)',
    'nav-border': 'transparent',
    'nav-bump': 'var(--color-surface)',
    // The tab strip and the "All" chip, at the values they have always had.
    'tab-active': 'rgba(0, 0, 0, 0.05)',
    'tab-inactive': 'rgba(0, 0, 0, 0.5)',
    control: '#ffffff',
    'control-border': 'var(--color-line)',
    disabled: '#d1d5db',
    chip: '#ffffff',
    'chip-text': 'rgba(0, 0, 0, 0.5)',
    'chip-border': 'var(--color-line)',
    // Tailwind's gray-100 / gray-200, the shimmer this app has always used.
    skeleton: '#f3f4f6',
    'skeleton-shine': '#e5e7eb',
    // Artwork-led tokens. This client runs the flat v2 Home, so the CTA
    // gradient resolves to its brand colour and nothing changes.
    'brand-gradient': 'var(--color-brand)',
    'brand-gradient-text': 'var(--color-accent-text)',
    badge: 'var(--color-danger)',
    'badge-text': '#ffffff',
    'nav-badge': 'var(--color-danger)',
    'nav-badge-text': '#ffffff',
    watermark: 'rgba(0, 0, 0, 0.04)',
  },

  assets: {
    cdn: 'https://pub-dbd64b2aa45940c2ba68ae732da32aa0.r2.dev',
  },

  support: {
    telegram: '@kf99h',
  },

  referral: {
    shareBase: 'https://hg.game/r/',
  },

  features: {
    originalGames: true,
    referralProgram: true,
    telegramAuth: true,
    tgQuickSignIn: true,
    rememberPassword: true,
    pwaBanner: true,
    liveChat: true,
    noticeMarquee: true,
    notifications: true,
    followTelegramTheme: false,
    accountInHeader: false,
  },
};
